import React from "react";
import * as S from "./styled";
import moment from "moment";
import { ORDERS_NS as ns } from "@/i18n/ns";
import CroppedText from "_c/CroppedText";
import Price from "./Price";
import Info from "_c/atoms/Info";
import Photos from "./Photos";
import ClaimDetails from "./ClaimDetails";

const TaskItemView = ({
  task,
  Timers,
  note,
  className,
  Badges,
  Services,
  CustomFields,
  ClientExcerpt,
  viewMode,
  Interface,
  t,
}) => (
  <S.Wrap className={className} dir="ltr">
    <div>
      <S.Timing dateTime={task.start_date}>
        {viewMode === "scheduler"
          ? ""
          : moment(task.start_date).format("L") + " "}
        {moment(task.start_date).format("HH:mm")} <span> - </span>
        {moment(task.end_date).format("HH:mm")}
      </S.Timing>
      {Timers}
      <div
        css={`
          display: flex;
          align-items: center;
        `}
      >
        {Badges}
        {ClientExcerpt}
      </div>
      <Photos task={task} />
      <div
        css={`
          margin-top: 5px;
          display: flex;
          max-width: 100%;
        `}
      >
        {task.personal ? (
          <div
            css={`
              font-weight: 700;
              margin-bottom: 5px;
              overflow-wrap: anywhere;
            `}
          >
            {task.title}
          </div>
        ) : (
          Services
        )}
        <div
          css={`
            margin-left: auto;
            flex: 0;
          `}
        >
          {Interface}
        </div>
      </div>
      <S.StatusWrap>
        <S.Status>{t(`${ns}:tooltips.status.${task.status}`)}</S.Status>
      </S.StatusWrap>
    </div>
    <div
      css={`
        display: flex;
      `}
    >
      {CustomFields}
    </div>
    <div>
      {note && (
        <div>
          <Info
            cta
            css={`
              display: inline-block;
            `}
          >
            <CroppedText Component={React.Fragment} limit={64} text={note} />
          </Info>
        </div>
      )}
      {task.claim && <ClaimDetails task={task} t={t} />}
      {task.status === "CANCELLED" && task.cancel_reason && (
        <div>
          <S.CloseableMessage
            css={`
              background-color: var(--color-danger) !important;
            `}
            name={`task_cncl_rsn__${task._id}`}
            header={t(`${ns}:cancel_reason`)}
            message={
              <CroppedText
                Component={React.Fragment}
                limit={64}
                text={task.cancel_reason}
              />
            }
          />
        </div>
      )}
      {task.anon_client_msg && (
        <div>
          <S.CloseableMessage
            name={`task_anon_msg__${task._id}`}
            header={t("common:task_client_msg")}
            message={
              <CroppedText
                Component={React.Fragment}
                limit={64}
                text={task.anon_client_msg}
              />
            }
          />
        </div>
      )}
    </div>
    {!task.personal && (
      <Price price={task.price} prepayment={task.prepayment} />
    )}
  </S.Wrap>
);

export default TaskItemView;
